// Shared address formatting for the Locations scene. Lives at the
// Locations root (alongside normalisers / mockLocations) rather than
// inside LocationsTab so both the list (LocationsTab/LocationRow) and the
// detail page (Detail/index) can import it without crossing a sibling
// sub-scene boundary — see CLAUDE.md "shared code goes up, never sideways".

// "street, city, state zip" with missing pieces compacted — a location
// lacking street/city must not render dangling commas (", , California").
export const formatAddressLine = (location: {
  street?: string | null
  city?: string | null
  state?: string | null
  zip?: string | null
}): string => {
  const stateZip = [location.state, location.zip].filter(Boolean).join(' ')
  return [location.street, location.city, stateZip]
    .filter(part => part && String(part).trim() !== '')
    .join(', ')
}
